import { useEffect } from 'react'
import { Route, Routes, Navigate } from 'react-router'
import Signin from './Signin'
import Home from './Home'
import Dashboard from './Dashboard'
import Products from './Products'
import Layout from '../components/Layout'
import routes from './routes'
import { useSetRecoilState } from 'recoil'
import { sessionState } from '../state'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

const App = () => {
  const setSession = useSetRecoilState(sessionState)

  // Subscribe to firebase auth
  useEffect(
    () =>
      onAuthStateChanged(getAuth(), resultUser => {
        setSession({
          isAuthenticating: false,
          user: resultUser && {
            uid: resultUser.uid,
            email: resultUser.email,
            displayName: resultUser.displayName
          }
        })
      }),
    [setSession]
  )

  return (
    <Layout>
      <Routes>
        <Route path={routes.signin} element={<Signin />} />
        <Route path={routes.home} element={<Home />} />
        <Route path={routes.dashboard} element={<Dashboard />} />
        <Route path={routes.products} element={<Products />} />
        <Route path={routes.billing} element={<div>Billing Page - Coming Soon</div>} />
        <Route path={routes.account} element={<div>Account Settings - Coming Soon</div>} />
        <Route path='*' element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}

export default App
